import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getInfluencer = createAsyncThunk('influencer/getInfluencer', async (page = 1, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/influencers?limit=10&page=${page}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getInfluencerById = createAsyncThunk('influencer/getInfluencerById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/influencers/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const createInfluencer = createAsyncThunk('users/createUserInfluencer', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/admin/influencers`, { ...payload });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateInfluencer = createAsyncThunk('influencer/updateInfluencer', async (payload, thunkAPI) => {
  const { id, data } = payload;

  try {
    const response = await axiosInstance.put(`/admin/influencers/${id}`, { ...data });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteInfluencer = createAsyncThunk('influencer/deleteInfluencer', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/admin/influencers/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getReferralHistory = createAsyncThunk('influencer/getReferralHistory', async (payload, thunkAPI) => {
  const { id, page, keyword } = payload;

  const params = new URLSearchParams();
  params.append('referrer_id', id);
  params.append('page', page);
  params.append('limit', '10');
  if (keyword) params.append('keyword', keyword);

  try {
    const response = await axiosInstance.get(`/admin/influencer-history?${params.toString()}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const generateReferralCode = createAsyncThunk('influencer/generateReferralCode', async (name, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/generate-referral-code?name=${encodeURIComponent(name)}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getInfluencerChart = createAsyncThunk('influencer/generateReferralCode', async (name, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/generate-referral-code?name=${encodeURIComponent(name)}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// ACTIONS TO GET INFLUENCER STATS
export const getTotalInfluencer = createAsyncThunk(
  'influencerStats/getTotalInfluencer',
  async (payload = { startDate: '', endDate: '' }, thunkAPI) => {
    let url = `/admin/influencer-chart?type=total_influencer`;

    const { startDate, endDate } = payload;

    if (startDate) {
      url = url + `&start_date=${startDate}`;
    }

    if (endDate) {
      url = url + `&end_date=${endDate}`;
    }

    try {
      const response = await axiosInstance.get(`${url}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getTransactionStats = createAsyncThunk(
  'influencerStats/getTransactionStats',
  async (payload = { startDate: '', endDate: '' }, thunkAPI) => {
    let url = `/admin/influencer-chart?type=trx_stats`;

    const { startDate, endDate } = payload;

    if (startDate) {
      url = url + `&start_date=${startDate}`;
    }

    if (endDate) {
      url = url + `&end_date=${endDate}`;
    }

    try {
      const response = await axiosInstance.get(`${url}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getCurrentPeriodTransactionStats = createAsyncThunk(
  'influencerStats/getCurrentPeriodTransactionStats',
  async (payload = { startDate: '', endDate: '' }, thunkAPI) => {
    const { startDate, endDate, id, type } = payload;

    let url = `/admin/influencer-chart?referrer_id=${id}&type=${type}`;

    if (startDate) {
      url = url + `&start_date=${startDate}`;
    }

    if (endDate) {
      url = url + `&end_date=${endDate}`;
    }

    try {
      const response = await axiosInstance.get(`${url}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);
